module.exports = __webpack_public_path__ + "static/media/main idea.346f300d.mp3";